import React from 'react'
import { useTranslation } from 'react-i18next'

const AllFieldsRequiredLabel = () => {
  const { t } = useTranslation()
  return (
    <p className='text-sm'>
      <span className='text-red-500'>*</span> {t('allFieldsAreRequired')}
    </p>
  )
}

export default AllFieldsRequiredLabel
